import {
  FETCH_CHAPTERS_REQUEST,
  FETCH_CHAPTERS_SUCCESS,
  FETCH_CHAPTERS_FAILURE,
  ADD_CHAPTER_REQUEST,
  ADD_CHAPTER_SUCCESS,
  ADD_CHAPTER_FAILURE,
  UPDATE_CHAPTER_REQUEST,
  UPDATE_CHAPTER_SUCCESS,
  UPDATE_CHAPTER_FAILURE,
  DELETE_CHAPTER_REQUEST,
  DELETE_CHAPTER_SUCCESS,
  DELETE_CHAPTER_FAILURE,
} from './actionTypes';

const initialState = {
  chapters: { data: [] }, 
  loading: false,
  error: null,
};

const chapterReducer = (state = initialState, action) => {
  switch (action.type) {
    // ─────────────── FETCH ───────────────
    case FETCH_CHAPTERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CHAPTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        chapters: action.payload || { data: [] },
      };

    case FETCH_CHAPTERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ─────────────── ADD ───────────────
    case ADD_CHAPTER_REQUEST:
    case UPDATE_CHAPTER_REQUEST:
    case DELETE_CHAPTER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ADD_CHAPTER_SUCCESS:
      return {
        ...state,
        loading: false,
        chapters: {
          ...state.chapters,
          data: [
            ...(state.chapters?.data || []), // ensure array exists
            action.payload?.data,
          ],
        },
      };

    case ADD_CHAPTER_FAILURE:
    case UPDATE_CHAPTER_FAILURE:
    case DELETE_CHAPTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ─────────────── UPDATE ───────────────
    case UPDATE_CHAPTER_SUCCESS:
      return {
        ...state,
        loading: false,
        chapters: {
          ...state.chapters,
          data: (state.chapters?.data || []).map((item) =>
            item?._id === action.payload?.data?._id
              ? action.payload.data
              : item
          ),
        },
      };

    // ─────────────── DELETE ───────────────
    case DELETE_CHAPTER_SUCCESS:
      return {
        ...state,
        loading: false,
        chapters: {
          ...state.chapters,
          data: (state.chapters?.data || []).filter(
            (item) => item?._id !== action.payload?.data?._id
          ),
        },
      };

    default:
      return state;
  }
};

export default chapterReducer;
